module.exports = __webpack_public_path__ + "static/media/audioml1.4b4ad862.jpg";